
export class SwitchApp {
    static readonly CONDUCTORES : SwitchAppItem = {
        text: "CONDUCTORES",
        iniroute: "conductores/listado-servicios",
        inibreadcumb: "Servicios",
        image: `assets/layout/images/apps/CONDUCTORES.svg`,
        authexist: "codempleado",
        reqmatricula: false,
        haveChat: true
    };
    static readonly TAXIS : SwitchAppItem = {
        text: "TAXIS",
        iniroute: "taxis/form",
        inibreadcumb: "Nuevo",
        image: `assets/layout/images/apps/TAXIS.svg`,
        authexist: "loginTaxis",
        reqmatricula: true,
        haveChat: false
    };
  
}

 export class SwitchAppItem{
    text: string;
    iniroute: string;
    inibreadcumb: string;
    image: string;
    authexist: string;
    reqmatricula: boolean;
    haveChat: boolean;
 }